module.exports = __webpack_public_path__ + "static/media/task.1e66bdf0.svg";